// @flow
import AttributeModel from "./AttributeModel";

/**
 * Label Attribute model
 */
export default class LabelAttributeModel extends AttributeModel {
  /**
   */
  static isApplicableModel(contributions: Object): boolean {
    const layouthint = contributions?.layouthint;
    return (
      contributions.type === "label" ||
      (Array.isArray(layouthint) && layouthint.includes("label"))
    );
  }

  /**
   */
  get type(): string {
    return "label";
  }

  /**
   */
  // eslint-disable-next-line no-unused-vars
  update(value: string): LabelAttributeModel {
    return this;
  }

  /**
   */
  getFormData(): null {
    return null;
  }
}
